import { getUsedCouponCount } from '@cart-services/core/cartService'
import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { useDialog } from '@dni-hooks/useDialog'
import { DiscountItemType } from '@hooks-api/types/dataModel/coupon'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowRightSmall, RemindCircle, NoticeFilled } from '@pets-ui/icons'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useStmCart } from '../../CartProvider'
import { CouponManualInputCard } from './CouponManualInputCard'
import { DIALOG_COUPON, DialogCoupon } from './DialogCoupon'

export const CardCoupon = () => {
  const { campaignCode, campaignId, projectCode, countryCode, currency, platform } = useStmCart()
  const { calculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)
  const { openDialog } = useDialog(DIALOG_COUPON)

  const usedCount = getUsedCouponCount(calculateResult?.applied_coupons ?? [])
  const discountItems = calculateResult?.discount_items.filter(item => item.type === DiscountItemType.COUPON)
  const discountAmount = discountItems?.reduce((acc, item) => acc + item.discount_amount, 0) ?? 0
  const usedCountColor = usedCount > 0 ? colors.green600 : colors.yellow600

  return (
    <>
      <DialogCoupon
        campaignCode={campaignCode}
        campaignId={campaignId}
        projectCode={projectCode}
        countryCode={countryCode}
        currency={currency}
      />
      <Paper elevation={0} p={3} borderRadius={8}>
        <VStack gap={3}>
          <HStack justifyContent="space-between" alignItems="center">
            <Text variant="h5">優惠券</Text>
            <Button variant="text" color="blue" onClick={() => openDialog()}>
              <HStack gap={1} alignItems="center">
                <Text color={colors.blue600}>查看優惠</Text>
                <ArrowRightSmall color={colors.blue600} />
              </HStack>
            </Button>
          </HStack>
          <HStack alignItems="center" justifyContent="space-between">
            <HStack gap={1} alignItems="center">
              {usedCount > 0 ? <RemindCircle color={colors.green600} fontSize={16} /> : <NoticeFilled color={colors.yellow600} fontSize={16} />}
              <Text color={usedCountColor}>折抵優惠</Text>
              <Text color={usedCountColor}>{usedCount}</Text>
            </HStack>
            <HStack gap={1} alignItems="center">
              <Text color={colors.grey600}>已省下</Text>
              <Text color={colors.red600}>{`$ ${Math.floor(discountAmount)}`}</Text>
            </HStack>
          </HStack>
          <CouponManualInputCard />
        </VStack>
      </Paper>
    </>
  )
}
